import { useEffect, useRef } from 'react'
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import { useAuth, useSession, useSignIn } from '@clerk/clerk-react'
import Loading from '@/components/Loading'
import { useRedirectToLastUrl } from '@/hooks/useRedirectToLastUrl'
import { logger } from '@/logger/logger'

function SsoToken() {
  const { signInToken } = Route.useSearch()
  const navigate = useNavigate()
  const { signIn, setActive, isLoaded } = useSignIn()
  const { signOut } = useAuth()
  const { isSignedIn, session, isLoaded: isSessionLoaded } = useSession()
  const ran = useRef(false)
  useRedirectToLastUrl()

  useEffect(() => {
    if (!isLoaded || !isSessionLoaded || !signIn || !setActive || !signInToken || isSignedIn || ran.current) {
      return
    }

    const createSignIn = async () => {
      try {
        if (isSignedIn) {
          await signOut()
          await (session as any)?.remove()
          await setActive({ session: null })
        }

        const signInAttempt = await signIn.create({
          strategy: 'ticket',
          ticket: signInToken,
        })

        if (signInAttempt.status === 'complete') {
          await setActive({ session: signInAttempt.createdSessionId })
        } else {
          logger.error('Sign in attempt failed')
        }
      } catch (err) {
        logger.error('SSO Token Error', err)
        await navigate({ to: '/logout' })
      }
    }

    void createSignIn()
    ran.current = true
  }, [signIn, setActive, signInToken, isLoaded, isSessionLoaded, isSignedIn])

  return <Loading />
}

export const Route = createFileRoute('/sso-token')({
  validateSearch: (search: Record<string, unknown>) => ({
    signInToken: search.signInToken as string | undefined,
  }),
  component: SsoToken,
})
